import { render, staticRenderFns } from "./TempateManageTestView.vue?vue&type=template&id=8f432b90"
import script from "./TempateManageTestView.vue?vue&type=script&lang=ts"
export * from "./TempateManageTestView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports